import Button from 'src/components/Button';
import NavFooterLayout from 'src/components/Layouts/NavFooterLayout';
import SocialIcon, { SocialIconType } from 'src/components/Socials/SocialIcon';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

const socials: SocialIconType[] = ['twitter', 'discord', 'canny'];

const PREVIEW_LINK_SUFFIX = 'drift-web.vercel.app';

const ErrorPage = ({ error }: { error: any }) => {
	const domain = window.location.hostname;

	const isPreviewLink = domain.includes(PREVIEW_LINK_SUFFIX);
	const isMobile = useIsMobileScreenSize();

	return (
		<NavFooterLayout currentPage="error">
			<div className="relative h-full mx-4 rounded bg-container-bg">
				<div className="flex flex-col items-center justify-center">
					<img
						src="/assets/icons/stop.svg"
						className="w-40 h-40 xs:mt-10 sm:mt-24"
					/>
					<div className="font-black text-text-emphasis xs:text-6xl sm:text-7xl">
						Whoops!
					</div>
					<div className="mb-6 font-bold text-text-emphasis xs:text-xl sm:text-2xl">
						We&apos;ve drifted a bit too far.
					</div>
					<div className="w-7/12 mb-6 text-center xs:text-md sm:text-lg text-text-default">
						Something&apos;s gone wrong with the action you&apos;ve performed.
						Try again, and if this action persists, please reach out and let us
						know so we can try and fix this problem.
					</div>
					<div className="flex items-center justify-between gap-8 mb-6">
						{socials.map((type) => (
							<SocialIcon
								key={type}
								type={type}
								className="flex justify-center w-12 text-text-emphasis hover:opacity-80"
							/>
						))}
					</div>
					<div className="flex items-center justify-between space-x-4">
						<a href="https://app.drift.trade/">
							<Button.Secondary
								className="w-full"
								size="LARGE"
								highlight
								onClick={null}
							>
								Take me home
							</Button.Secondary>
						</a>
						<a href="https://backup.drift.trade/">
							<Button.Secondary className="w-full" size="LARGE" onClick={null}>
								Visit Backup Site
							</Button.Secondary>
						</a>
					</div>
				</div>

				{/** Used to debug on mobile phones where access to console is not available */}
				{isPreviewLink && isMobile && !!error && (
					<div className="absolute mb-4 mr-4 overflow-auto text-xs right-2 bottom-2 left-2 top-10 text-text-default bg-red-50">
						{JSON.stringify(error)}
					</div>
				)}
			</div>
		</NavFooterLayout>
	);
};

export default ErrorPage;
